// 🔧 social_links.js
// ✅ Purpose: Central social/profile links for Let's Go Vote
// ✅ Features:
// - Keeps Facebook, Instagram, and LinkedIn URLs in one place
// - Used by footer, marketing SEO, and future social sharing features

export const SOCIAL_LINKS = {
  facebook: "https://www.facebook.com/letsgovoteapp",
  instagram: "https://www.instagram.com/letsgovoteapp/",
  linkedin: "https://www.linkedin.com/company/132004035/admin/dashboard/",
};